import { render, staticRenderFns, recyclableRender, components } from "./modify-phone.vue?vue&type=template&id=167184f8&scoped=true&"
var renderjs
import script from "./modify-phone.vue?vue&type=script&lang=js&"
export * from "./modify-phone.vue?vue&type=script&lang=js&"
import style0 from "./modify-phone.vue?vue&type=style&index=0&id=167184f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167184f8",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/user/modify-phone/modify-phone.vue"
export default component.exports